import noop from 'lodash/noop';
import React, { useContext } from 'react';
import { Installments } from '../Cart/OrderSummary/types';

import { useCheckoutInternal, CheckoutContext } from './UseCheckout';
import { defaultErrorState } from './Utils';

const initialContext: CheckoutContext = {
  emailAddress: '',
  setEmailAddress: noop,
  phoneNumber: '',
  userInfo: null,
  setUserInfo: noop,
  isUserInfoValid: false,
  setUserInfoValid: noop,
  isLoading: false,
  setIsLoading: noop,
  selectedPurchaseType: Installments.P,
  setSelectedPurchaseType: noop,
  hasApplicationError: false,
  setHasApplicationError: noop,
  errorState: defaultErrorState,
  setErrorState: noop,
  landlinePhoneNumber: '',
  setLandlinePhoneNumber: noop,
  continueButtonRef: React.createRef(),
  leadId: '',
  setLeadId: noop,
  hasClaimedOtpAccount: false,
  setHasClaimedOtpAccount: noop,
};

const Checkout = React.createContext<CheckoutContext>(initialContext);

export const useCheckout = () => useContext(Checkout);

export const CheckoutProvider: React.FC = ({ children }) => {
  return <Checkout.Provider value={useCheckoutInternal()}>{children}</Checkout.Provider>;
};
